"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var grommet_1 = require("grommet");
var map = require("lodash/map");
var React = require("react");
var asRendition_1 = require("../asRendition");
var TabsBase = function (_a) {
    var children = _a.children, tabs = _a.tabs, props = __rest(_a, ["children", "tabs"]);
    return (React.createElement(grommet_1.Tabs, __assign({ justify: "start" }, props), map(children, function (child, index) {
        return (React.createElement(grommet_1.Tab, { key: tabs[index], title: tabs[index] }, child));
    })));
};
exports.default = asRendition_1.default(TabsBase);



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/Tabs.js
// module id = 792
// module chunks = 2